import React from 'react';

const PoliticaPrivacidade = ({ onVoltar }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Cabeçalho com botão de voltar */}
        <div className="mb-8">
          <button 
            onClick={onVoltar} 
            className="inline-flex items-center text-purple-600 hover:text-purple-800 transition-colors duration-300"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar para a página inicial
          </button>
        </div>

        {/* Card principal */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Cabeçalho do card */}
          <div className="bg-gradient-to-r from-purple-600 to-indigo-700 p-8 text-center">
            <h1 className="text-4xl font-bold text-white mb-4">Política de Privacidade</h1>
            <p className="text-xl text-purple-200">Última atualização: 14 de setembro de 2025</p>
          </div>

          {/* Conteúdo */}
          <div className="p-8">
            <div className="prose prose-purple max-w-none">
              {/* Seção 1: Introdução */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">1</div>
                  <h2 className="text-2xl font-bold text-gray-900">Introdução</h2>
                </div>
                <p className="text-gray-700 mb-4 text-lg leading-relaxed">
                  A sua privacidade é importante para nós. É política do <span className="font-semibold text-purple-600">Vestibula</span> respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site Vestibula.
                </p>
                <p className="text-gray-700 mb-4 text-lg leading-relaxed">
                  Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, os protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.
                </p>
              </section>

              {/* Seção 2: Informações que Coletamos */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">2</div>
                  <h2 className="text-2xl font-bold text-gray-900">Informações que Coletamos</h2>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Coletamos informações pessoais como <span className="font-semibold">nome, e-mail</span> e <span className="font-semibold">dados de uso</span> quando você se registra em nossa plataforma ou utiliza nossos serviços. Também podemos coletar informações técnicas como <span className="font-semibold">endereço IP, tipo de navegador</span> e <span className="font-semibold">dados de navegação</span> para melhorar nossa plataforma.
                </p>
              </section>

              {/* Seção 3: Uso das Informações */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">3</div>
                  <h2 className="text-2xl font-bold text-gray-900">Uso das Informações</h2>
                </div>
                <p className="text-gray-700 mb-4 text-lg leading-relaxed">
                  Utilizamos as informações coletadas para:
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <div className="bg-purple-500 rounded-full p-1 mt-1 mr-3">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                    </div>
                    <span className="text-gray-700 text-lg">Fornecer e manter nossos serviços</span>
                  </li>
                  <li className="flex items-start">
                    <div className="bg-purple-500 rounded-full p-1 mt-1 mr-3">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                    </div>
                    <span className="text-gray-700 text-lg">Personalizar sua experiência de aprendizado</span>
                  </li>
                  <li className="flex items-start">
                    <div className="bg-purple-500 rounded-full p-1 mt-1 mr-3">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                    </div>
                    <span className="text-gray-700 text-lg">Comunicar atualizações e novidades</span>
                  </li>
                  <li className="flex items-start">
                    <div className="bg-purple-500 rounded-full p-1 mt-1 mr-3">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                    </div>
                    <span className="text-gray-700 text-lg">Melhorar nossos produtos e serviços</span>
                  </li>
                  <li className="flex items-start">
                    <div className="bg-purple-500 rounded-full p-1 mt-1 mr-3">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                    </div>
                    <span className="text-gray-700 text-lg">Cumprir obrigações legais</span>
                  </li>
                </ul>
              </section>

              {/* Seção 4: Compartilhamento de Informações */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">4</div>
                  <h2 className="text-2xl font-bold text-gray-900">Compartilhamento de Informações</h2>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprir obrigações legais ou proteger nossos direitos. Podemos compartilhar dados agregados e anonimizados para fins de análise e melhoria de nossos serviços.
                </p>
              </section>

              {/* Seção 5: Cookies e Tecnologias de Rastreamento */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">5</div>
                  <h2 className="text-2xl font-bold text-gray-900">Cookies e Tecnologias de Rastreamento</h2>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Utilizamos cookies e tecnologias similares para melhorar sua experiência em nossa plataforma. Você pode gerenciar suas preferências de cookies através das configurações do seu navegador.
                </p>
              </section>

              {/* Seção 6: Segurança dos Dados */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">6</div>
                  <h2 className="text-2xl font-bold text-gray-900">Segurança dos Dados</h2>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação, ou destruição.
                </p>
              </section>

              {/* Seção 7: Seus Direitos */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">7</div>
                  <h2 className="text-2xl font-bold text-gray-900">Seus Direitos</h2>
                </div>
                <p className="text-gray-700 mb-4 text-lg leading-relaxed">
                  Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. Também pode retirar seu consentimento a qualquer momento. Para exercer esses direitos, entre em contato conosco através do e-mail:
                </p>
                <p className="text-lg">
                  <a href="mailto:suporte@vestibula.com.br" className="text-purple-600 hover:text-purple-800 font-semibold underline transition-colors duration-300">
                    suporte@vestibula.com.br
                  </a>
                </p>
              </section>

              {/* Seção 8: Alterações nesta Política */}
              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">8</div>
                  <h2 className="text-2xl font-bold text-gray-900">Alterações nesta Política</h2>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Podemos atualizar nossa Política de Privacidade de tempos em tempos. Notificaremos você sobre quaisquer alterações publicando a nova política nesta página.
                </p>
              </section>

              {/* Seção 9: Contato */}
              <section>
                <div className="flex items-center mb-6">
                  <div className="bg-purple-100 text-purple-800 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mr-4">9</div>
                  <h2 className="text-2xl font-bold text-gray-900">Contato</h2>
                </div>
                <p className="text-gray-700 mb-4 text-lg leading-relaxed">
                  Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco:
                </p>
                <div className="bg-purple-50 rounded-xl p-6 border border-purple-200">
                  <p className="text-lg mb-2">
                    <span className="font-semibold text-gray-900">E-mail:</span>{' '}
                    <a href="mailto:suporte@vestibula.com.br" className="text-purple-600 hover:text-purple-800 font-semibold underline transition-colors duration-300">
                      suporte@vestibula.com.br
                    </a>
                  </p>
                </div>
              </section>
            </div>
          </div>

          {/* Rodapé do card */}
          <div className="bg-gray-50 px-8 py-6 border-t border-gray-200">
            <p className="text-center text-gray-600 text-sm">
              &copy; 2025 Vestibula. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;